import React from "react";
import { ComingSoon } from "../ComingSoon";
import "./InProgress.css";

export const InProgress = () => {
  return (
    <div className="in-progress-page-layout">
      <div className="in-progress-page-content">
        <ComingSoon />
      </div>
    </div>
  );
};
